<script>
import { GlButton } from '@gitlab/ui';
import * as Sentry from '~/sentry/sentry_browser_wrapper';
import { s__ } from '~/locale';
import glFeatureFlagsMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import { findAgentPlanWidget, isAgentPlanEnabled } from 'ee/work_items/utils';
import workItemEnableAiPlanningMutation from 'ee/work_items/graphql/work_item_enable_ai_planning.mutation.graphql';

export default {
  name: 'WorkItemPlanCta',
  components: {
    GlButton,
  },
  mixins: [glFeatureFlagsMixin()],
  props: {
    workItem: {
      type: Object,
      required: true,
    },
    canUpdate: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['error'],
  data() {
    return {
      isEnabling: false,
    };
  },
  computed: {
    showPlanButton() {
      return (
        this.canUpdate &&
        Boolean(findAgentPlanWidget(this.workItem)) &&
        !isAgentPlanEnabled(this.workItem)
      );
    },
  },
  methods: {
    async enableAiPlanning() {
      this.isEnabling = true;
      try {
        const { data } = await this.$apollo.mutate({
          mutation: workItemEnableAiPlanningMutation,
          variables: {
            input: { id: this.workItem.id },
            useWorkItemFeatures: Boolean(this.glFeatures?.workItemFeaturesField),
          },
        });

        if (data.workItemEnableAiPlanning.errors.length) {
          this.$emit('error', data.workItemEnableAiPlanning.errors.join('\n'));
        }
      } catch (error) {
        this.$emit(
          'error',
          s__(
            'WorkItem|Something went wrong while enabling planning for this item. Please try again.',
          ),
        );
        Sentry.captureException(error);
      } finally {
        this.isEnabling = false;
      }
    },
  },
};
</script>

<template>
  <gl-button
    v-if="showPlanButton"
    icon="tanuki-ai"
    :loading="isEnabling"
    category="tertiary"
    size="small"
    data-testid="work-item-plan-cta"
    @click="enableAiPlanning"
  >
    {{ s__('WorkItem|Plan') }}
  </gl-button>
</template>
